import styles from './TelegramCHannel.module.css'
import icMax from './../../../../image/ic_max.svg'
export const MaxChannel = () =>{
    return (
        <div className={styles.telegram_container} onClick={()=>window.location.href='https://max.ru/join/BmF_eQieEv1J8BqmMpoatLdmUZ2vvCXX-mITGddHOk4'}>
            <img src={icMax}/>
            <div className={styles.telegram_container_body}>MAX-канал проекта </div>
        </div>
    )
}